import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {CheckoutComponent} from './checkout/checkout.component';
import {ParticipateComponent} from './participate/participate.component';
import {CheckoutParamsGuard} from './guards/checkout-params.guard';
import {ShareComponent} from "./share/share.component";
import {TestCheckoutComponent} from "./test-checkout/test-checkout.component";
import {NotFoundComponent} from "./not-found/not-found.component";
import {ParticipateResponseComponent} from "./participate-response/participate-response.component";

const routes: Routes = [
  {path: 'checkout', component: CheckoutComponent, canActivate: [CheckoutParamsGuard]},
  {path: 'participate/:purchaseId', component: ParticipateComponent},
  {path: 'share/:purchaseId', component: ShareComponent},
  {path: 'participate-response', component: ParticipateResponseComponent},
  {path: 'test-checkout', component: TestCheckoutComponent},
  {path: '404', component: NotFoundComponent},
  {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts